import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getProjectsSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.Projects.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);
        if(filters.master) queryString = queryString.concat(`&master=${filters.master}`);

        const { data } = yield API.get(`/projects?${queryString}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_PROJECTS_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_PROJECTS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_PROJECTS_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createProjectSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData } = payload;

        const { data } = yield API.post("/projects", formData);

        if (data.success) {
            yield put({ type: actionTypes.CREATE_PROJECT_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PROJECTS, params: {} });
        } else {
            toast.error(data?.message || "Could not save project.");
            yield put({ type: actionTypes.CREATE_PROJECT_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save project.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_PROJECT_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateProjectSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { formData } = payload;
        const id = formData.id;
        delete formData.id;

        const { data } = yield API.put(`/projects/${id}`, formData);

        if (data.success) {
            const { pagination } = yield select((state) => state.Projects.ProjectsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_PROJECT_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PROJECTS, params });
        } else {
            toast.error(data?.message || "Could not save updated project data.");
            yield put({ type: actionTypes.UPDATE_PROJECT_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated project data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_PROJECT_FAILURE, payload: data || { message: "Internal server error" } });
    }
}

function* updateProjectStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.patch(`/projects/${Id}/status`);

        if (data.success) {
            const { pagination } = yield select((state) => state.Projects.ProjectsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_PROJECT_STATUS_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PROJECTS, params });
        } else {
            toast.error(data?.message || "Could not update project status.");
            yield put({ type: actionTypes.UPDATE_PROJECT_STATUS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update project status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_PROJECT_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteProjectSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/projects/${Id}`);

        if (data.success) {
            const { pagination } = yield select((state) => state.Projects.ProjectsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.DELETE_PROJECT_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_PROJECTS, params });
        } else {
            toast.error(data?.message || "Could not delete project.");
            yield put({ type: actionTypes.DELETE_PROJECT_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete project.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_PROJECT_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* ProjectsSaga() {
  yield all([
    takeLatest(actionTypes.GET_PROJECTS, getProjectsSaga),
    takeLatest(actionTypes.CREATE_PROJECT, createProjectSaga),
    takeLatest(actionTypes.UPDATE_PROJECT, updateProjectSaga),
    takeLatest(actionTypes.UPDATE_PROJECT_STATUS, updateProjectStatusSaga),
    takeLatest(actionTypes.DELETE_PROJECT, deleteProjectSaga),
  ]);
}

export default ProjectsSaga;
